import React from 'react';
import { AlertTriangleIcon, CheckCircle2Icon, RefreshCwIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
const included = ['6 Tomos completos', '6 Bonos estratégicos ($120 USD)', '40 semanas resueltas', 'Acceso inmediato en 5 minutos'];
export function Offer({
  id
}: {
  id?: string;
}) {
  return <section id={id} className="bg-white px-4 py-16" data-id="element-140">
      <div className="mx-auto max-w-md" data-id="element-141">
        <div className="rounded-2xl border-2 border-magenta/20 bg-magenta/5 p-5 text-center" data-id="element-142">
          <p className="text-xs font-bold uppercase tracking-widest text-magenta" data-id="element-143">
            ⏰ Precio de lanzamiento — cierra en:
          </p>
          <div className="mt-3" data-id="element-144">
            <Countdown data-id="element-145" />
          </div>
          <p className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-navy/70" data-id="element-146">
            <AlertTriangleIcon className="h-4 w-4 text-magenta" data-id="element-147" />
            Después sube $30 USD. No vuelve.
          </p>
        </div>

        <div className="mt-4 rounded-xl bg-navy/5 px-4 py-3" data-id="element-148">
          <div className="mb-1.5 flex items-center justify-between text-xs font-bold text-navy" data-id="element-149">
            <span className="text-magenta" data-id="element-150">🔴 68% de cupos tomados</span>
            <span className="text-navy/50" data-id="element-151">Precio lanzamiento</span>
          </div>
          <div className="h-2.5 w-full overflow-hidden rounded-full bg-navy/10" data-id="element-152">
            <div className="h-full w-[68%] rounded-full bg-magenta" data-id="element-153" />
          </div>
        </div>

        <div className="mt-6 overflow-hidden rounded-3xl border border-navy/10 bg-white shadow-soft" data-id="element-154">
          <div className="bg-navy px-6 py-5 text-center text-white" data-id="element-155">
            <h3 className="font-display text-xl font-black" data-id="element-156">
              📘 Método Domingo Libre
            </h3>
            <p className="mt-1 text-sm text-white/70" data-id="element-157">
              6 Tomos + 6 Bonos · 40 semanas resueltas
            </p>
          </div>
          <div className="px-6 py-6" data-id="element-158">
            <ul className="space-y-2.5" data-id="element-159">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm" data-id="element-160">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal" data-id="element-161" />
                  <span className="font-medium text-navy/80" data-id="element-162">{item}</span>
                </li>)}
            </ul>

            <div className="mt-6 text-center" data-id="element-163">
              <span className="font-display text-xl font-bold text-navy/40 line-through" data-id="element-164">
                $97 USD
              </span>
              <div className="mt-1 font-display text-5xl font-black text-magenta" data-id="element-165">
                $12.99 <span className="text-2xl" data-id="element-166">USD</span>
              </div>
              <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-navy/50" data-id="element-167">
                Un solo pago · Acceso de por vida
              </p>
              <p className="mx-auto mt-3 inline-flex items-center justify-center gap-1.5 rounded-full bg-teal/10 px-3 py-1.5 text-xs font-bold text-teal" data-id="element-168">
                <RefreshCwIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-169" />
                Cambio de moneda automático según tu país.
              </p>
            </div>

            <div className="mt-6" data-id="element-170">
              <CtaButton data-id="element-171" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}